export default function Privacidade() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10 md:py-14" data-testid="privacy-page">
      <h1 className="font-serif text-3xl tracking-tight text-navy md:text-4xl">Política de Privacidade</h1>
      <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground/75">
        <p>
          A Huddersfield Tecidos utiliza os dados informados nas solicitações (nome, WhatsApp,
          e-mail e cidade) exclusivamente para atendimento: confirmação de disponibilidade,
          metragens e valores dos tecidos solicitados.
        </p>
        <p>
          Não compartilhamos seus dados com terceiros e não enviamos comunicações promocionais sem
          consentimento. Você pode solicitar a exclusão dos seus dados a qualquer momento pelo
          WhatsApp (41) 3224-4723.
        </p>
        <p>
          As informações enviadas na sua solicitação são gravadas com segurança no servidor da loja
          e usadas apenas para o atendimento comercial pela equipe Huddersfield.
        </p>
      </div>
    </main>
  );
}
